module.exports = __webpack_public_path__ + "static/media/UE-EN-Top-black.524a13fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UE-EN-Top-black.svg
// module id = 239
// module chunks = 0